import { Component, OnInit, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LimitedTimeEvent } from '@app/shared/models/limitedTimeEvent.model';
import { Modal, ModalConfig, ModalType } from '@app/shared/models/modal.model';
import { Display, FontSizeRescalerService } from '@app/shared/services/font-rescaler.service';
import { LoggerService } from '@app/shared/services/logger.service';
import { EventManager } from '@app/shared/utils/event-manager';
import { TranslateService } from '@ngx-translate/core';
import { DisplayComponent } from '@app/shared/components/display/display.component';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { SharedModule } from '@app/shared/shared.module';

@Component({
  selector: 'slotcom-progressbag-reward-modal',
  templateUrl: './progressbag-reward.component.html',
  styleUrls: ['./progressbag-reward.component.scss'],
  standalone: true,
  imports: [DisplayComponent, SharedModule, ButtonComponent],
})
export class ProgressbagRewardModalComponent implements OnInit {
  protected readonly progressbagRewardModalData = inject<ModalConfig>(MAT_DIALOG_DATA);
  private eventManager = inject(EventManager);
  public logger = inject(LoggerService);
  private translateService = inject(TranslateService);
  private fontSizeRescalerService = inject(FontSizeRescalerService);

  lang = signal<string>('');
  progressbag = signal<LimitedTimeEvent | null>(null);

  ngOnInit(): void {
    this.lang.set(this.translateService.currentLang);
  }

  setFontSize(): string {
    return this.fontSizeRescalerService.setFontSize(
      Display.LargeDisplay,
      this.progressbagRewardModalData.reward.credits
    );
  }

  closeModal(): void {
    this.eventManager.closeModal(
      new Modal(this.progressbagRewardModalData.id, ModalType.Persisted, this.progressbagRewardModalData)
    );
  }
}
